import type {ComputationResult} from './../computation-result';
import type {Computation} from './../computation';
import type {_AvailableResult} from './../available-result';

export namespace Spearman {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.bivariate.Spearman$SpearmanResult
     */
    export interface SpearmanResult extends _AvailableResult {
        correlation: number;
        pvalue: number;

        // PolyJson type
        type: 'spearman';
    }

    export namespace SpearmanResult {
        export const type = 'spearman';
    }

    /** @deprecated Use ComputationResult.isSpearmanResult() */ export function isSpearmanResult(toTest: ComputationResult): toTest is SpearmanResult { return SpearmanResult.type === toTest['type']; }
}

/**
 * Generated from com.dataiku.dip.eda.compute.computations.bivariate.Spearman
 */
export interface Spearman extends Computation._BivariateComputation {
    // PolyJson type
    type: 'spearman';
}

export namespace Spearman {
    export const type = 'spearman';
}

/** @deprecated Use Computation.isSpearman() */ export function isSpearman(toTest: Computation): toTest is Spearman { return Spearman.type === toTest['type']; }